import { Accordion, Text } from "@merge-api/merge-javascript-shared";

interface DifferentFieldAccordionProps {
  different_fields?: string[];
}

const DifferentFieldAccordion = ({ different_fields }: DifferentFieldAccordionProps) => {
  if (!different_fields) return null;

  const lengthOfDifferentFields = different_fields.length;

  return (
    <Accordion
      className="mx-8 mb-3 py-3 px-4 bg-[#F7F8F9]"
      chevronOrientation="down"
      chevronColor="gray"
      variant="outline"
      title={
        <Text as="div" variant="h6">
          {lengthOfDifferentFields} different field{lengthOfDifferentFields !== 1 ? "s" : ""}
        </Text>
      }
    >
      <ul className="list-disc pl-5 mt-2">
        {different_fields.map((field, index) => (
          <li key={index}>{field}</li>
        ))}
      </ul>
    </Accordion>
  );
};

export default DifferentFieldAccordion;
